import { render } from "./Projects.htm?vue&type=template&id=64ff563a&scoped=true"
import script from "./Projects.js?vue&type=script&lang=js"
export * from "./Projects.js?vue&type=script&lang=js"

import "./Projects.scss?vue&type=style&index=0&id=64ff563a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ff563a"]])

export default __exports__